import Header from "../header/header";
import LeftMenuLogo from "../widgets/leftMenuLogo";
import MenuButton from "../widgets/menuButton";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import FoundationIcon from "@mui/icons-material/Foundation";
import "./home.css";
import { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { deleteToken } from "../../utils/util";
import { MOBILE_THRESHOLD } from "../../constants/constants";
import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import GroupIcon from "@mui/icons-material/Group";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Customers from "../customers/customers";
import Orders from "../orders/orders";
import Notifications from "../notifications/notifications";
import Transactions from "../transactions/transactions";
import TimelineIcon from "@mui/icons-material/Timeline";
import Timeline from "../timelines/timeline";
import UserDetails from "../orders/UserDetails";
import CocoonStock from "../customers/CocoonStock";
import SettingsPage from "../settings/SettingsPage";
import Support from "../support/support";
import PasswordReset from "./PasswordReset";
import StoreIcon from "@mui/icons-material/Store";
import PaymentDetailsForm from "../settings/PaymentDetailsForm";
import ToolsMarket from "../tools/ToolsMarket";
import SericultureToolsPage from "../tools/AddTools";
import ToolsPage from "../tools/ToolsPage";
import ViewProduct from "../tools/ViewProduct";
import AddCategoryForm from "../tools/AddCategoryForm";
import CategoriesList from "../tools/CategoriesList";
import ToolsSettingsPage from "../tools/ToolsSettingsPage";
import ToolsOrders from "../tools/ToolsOrders";
import ToolsOrderDetails from "../tools/ToolsOrderDetails";
import Stocks from "../stocks/Stocks";
import ManageBanners from "../banners/ManageBanners";
import BannerForm from "../banners/BannerForm";
import ToolsPayments from "../tools/ToolsPayments";
const Home = (props) => {
  const location = useLocation();
  const pos = location.pathname.split("/")[2] || "dashboard";
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const isMobile = windowSize.innerWidth < MOBILE_THRESHOLD;
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname, location.search, isMobile]);

  const logout = () => {
    deleteToken();
    navigate("/login");
  };
  const navigation = (
    <nav
      id="silkcart-navigation"
      aria-label="Main navigation"
      className={isMobile ? "silk-mobile-sidebar" : collapse ? "left_menu_box collapse" : "left_menu_box"}
      onClick={(event) => {
        if (isMobile && event.target.closest("a")) setMobileMenuOpen(false);
      }}
    >
      {isMobile && <IconButton className="silk-navigation-close" aria-label="Close navigation" onClick={() => setMobileMenuOpen(false)}><CloseIcon fontSize="small" /></IconButton>}
        <LeftMenuLogo collapse={isMobile ? false : collapse} />
        <div
          className="silk-navigation-links"
        >
          <MenuButton
            to="dashboard"
            collapse={isMobile ? false : collapse}
            text="My Dashboard"
            MenuIcon={DashboardCustomizeOutlinedIcon}
            active={!pos || pos === "dashboard"}
          />
          <MenuButton
            to="users"
            collapse={isMobile ? false : collapse}
            text="Users"
            MenuIcon={GroupIcon}
            active={pos === "users"}
          />
          <MenuButton
            to="orders"
            collapse={isMobile ? false : collapse}
            text="Orders"
            MenuIcon={AddShoppingCartIcon}
            active={pos === "orders"}
          />
          <MenuButton
            to="transactions"
            collapse={isMobile ? false : collapse}
            text="Payments"
            MenuIcon={DeliveryDiningIcon}
            active={pos === "transactions"}
          />
          <MenuButton
            to="add-payment-details"
            collapse={isMobile ? false : collapse}
            text="Account Details"
            MenuIcon={TimelineIcon}
            active={pos === "add-payment-details"}
          />
          <MenuButton
            to="cocoon-stock"
            collapse={isMobile ? false : collapse}
            text="Cocoon Stock"
            MenuIcon={FoundationIcon}
            active={pos === "cocoon-stock"}
          />
          <MenuButton
            to="stocks"
            collapse={isMobile ? false : collapse}
            text="Stocks"
            MenuIcon={InventoryOutlinedIcon}
            active={pos === "stocks"}
          />
          <MenuButton
            to="tools-market"
            collapse={isMobile ? false : collapse}
            text="Tools Market"
            MenuIcon={StoreIcon}
            active={["tools-market", "tools", "tools-orders", "tools-order", "tools-payments", "tools-settings", "banners", "categories", "add-tool", "add-banner", "add-form"].includes(pos) || /\/(edit-tool|view-tool|edit-banner)$/.test(location.pathname)}
          />
          <MenuButton
            to="notifications"
            collapse={isMobile ? false : collapse}
            text="Notifications"
            MenuIcon={NotificationsNoneIcon}
            active={pos === "notifications"}
          />
          <MenuButton
            to="user-support"
            collapse={isMobile ? false : collapse}
            text="User Support"
            MenuIcon={ContactSupportIcon}
            active={pos === "user-support"}
          />
          <MenuButton
            to="settings"
            collapse={isMobile ? false : collapse}
            text="Settings"
            MenuIcon={SettingsIcon}
            active={pos === "settings"}
          />

        </div>
    </nav>
  );
  return (
    <div className="home">
      <Header
        logout={logout}
        windowSize={windowSize}
        title={pos}
        collapse={isMobile ? !mobileMenuOpen : collapse}
        setCollapse={isMobile ? (nextCollapsed) => setMobileMenuOpen(!nextCollapsed) : setCollapse}
      />
      {isMobile ? (
        <Drawer
          variant="temporary"
          anchor="left"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          PaperProps={{ className: "silk-mobile-drawer" }}
        >
          {navigation}
        </Drawer>
      ) : navigation}
      <div
        style={{
          marginLeft: isMobile ? 0 : collapse ? 70 : 200,
          padding: 16,
        }}
      >
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Customers />} />
          <Route path="users/:userId" element={<UserDetails />} />
          <Route path="orders/*" element={<Orders />} />
          <Route path="add-payment-details" element={<PaymentDetailsForm />} />
          <Route path="transactions/*" element={<Transactions />} />
          <Route path="timelines" element={<Timeline />} />
          <Route path="tools-market" element={<ToolsMarket />} />
          <Route path="tools-payments" element={<ToolsPayments />} />
          <Route path="add-tool" element={<SericultureToolsPage />} />
          <Route path="add-form" element={<AddCategoryForm />} />
          <Route path="categories" element={<CategoriesList />} />
          <Route path=":id/edit-tool" element={<SericultureToolsPage />} />
          <Route path=":id/view-tool" element={<ViewProduct />} />
          <Route path="tools" element={<ToolsPage />} />
          <Route path="stocks" element={<Stocks />} />
          <Route path="cocoon-stock" element={<CocoonStock />} />
          <Route path="password-reset" element={<PasswordReset />} />
          <Route path="user-support" element={<Support />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="tools-settings" element={<ToolsSettingsPage />} />
          <Route path="banners" element={<ManageBanners />} />
          <Route path="add-banner" element={<BannerForm />} />
          <Route path=":id/edit-banner" element={<BannerForm />} />
          <Route path="tools-orders" element={<ToolsOrders />} />
          <Route path="tools-order/:id" element={<ToolsOrderDetails />} />
          <Route path="notifications" element={<Notifications />} />
        </Routes>
      </div>
    </div>
  );
};
export default Home;
